import { QuotationStatus } from '@/constants/quotation'
import { apiClient } from '@/lib/api/api-client'
import { Quotation } from '../types/quotation'

export const quotationApi = {
  // getQuotations: (productId: string) => {
  //   return apiClient.get<Quotation[]>(`products/${productId}/quotations`)
  // },

  getQuotations: (params?: { vendorId?: string; productId?: string; status?: QuotationStatus }) => {
    return apiClient.get<Quotation[]>(`quotations/`, { params })
  },

  getQuotation: (quotationId: string) => {
    return apiClient.get<Quotation>(`quotations/${quotationId}`)
  },

  createQuotation: (payload: any) => {
    return apiClient.post<Quotation>(`quotations/`, payload)
  },

  updateQuotation: (quotationId: string, payload: any) => {
    return apiClient.put<Quotation>(`quotations/${quotationId}`, payload)
  },

  submitQuotation: (quotationId: string) => {
    return apiClient.patch<any>(`quotations/${quotationId}/quotation/submit`)
  },
}
